<!-- TODO NEED OPTIMIZATION COMPONENT -->
<template>
  <section class="container-fluid">
    <div class="title-container" v-if="$can('read_all-backlog_reports')">
      <h3 class="title">
        Backlog time report
        <div
          class="spinner-border spinner-theme_default"
          role="status"
          v-if="showPreloader"
        >
                <span class="sr-only">
                  Loading...
                </span>
        </div>
      </h3>
      <div class="title-container__controls">
        <b-button
          class="button title-container__controls-item"
          :variant="isShowFilter ? 'secondary' : 'info'"
          @click="toggleShowFilter"
        >
          <span class="material-icons icon-image-preview">
            tune
          </span>
          Filters
        </b-button>
      </div>
    </div>

    <Filters
      v-if="$can('read_all-backlog_reports')"
      v-show="isShowFilter"
      textButtonSubmit="Get Report"
      :data="filters"
      :isLoading="showPreloader"
      @submit="filterReport"
    />

    <FullscreenTabs v-if="reportsByProject.length || sortReportsByUsers.length">
      <template v-slot:tabsControls>
        <div class="d-flex">
          <div class="table-tab-item" v-for="tab in tabs" :key="tab.name">
            <b-button
              class="button text-capitalize"
              :variant="tab.name === currentTab.name ? 'info' : 'secondary-outline'"
              @click="setCurrentTab(tab)"
            >
              {{ tab.alias }}
            </b-button>
          </div>
        </div>
      </template>
      <template v-slot:tabsContent>
        <div>
          <div class="" v-show="currentTab.name === 'byProject'">
            <TableForPage
              ref="tableProject"
              style="margin-bottom: 0;"
              :tableData="reportsByProject"
              :fields="fieldsProjects"
              :slots="slotsProjects"
            >
              <template v-slot:key="data">
                <a
                  :href="`https://giraffesoftware.atlassian.net/browse/${data.item.key}`"
                >
                  {{data.item.key}}
                </a>
              </template>
            </TableForPage>
          </div>
          <div v-show="currentTab.name === 'byPeople'">
            <TableForPage
              ref="tablePeople"
              style="margin-bottom: 0;"
              :tableData="sortReportsByUsers"
              :fields="fieldsPeople"
            >
              <template v-slot:row="slotProps">
                <NestedTable
                  :slotProps="slotProps"
                  :items="slotProps.row.item.projects"
                  :fields="fieldsNestedPeople"
                  :slots="slotsNestedPeople"
                  :modalFields="fieldsModalPeople"
                  :modalSlots="slotsModalPeople"
                  :funcModalTitle="setModalTitle"
                  rowName="tasks"
                  :showPagination="false"
                >
                  <template v-slot:modal-key="data">
                    <a
                      :href="`https://giraffesoftware.atlassian.net/browse/${data.item.key}`"
                    >{{data.item.key}}</a>
                  </template>
                  <template v-slot:key="data">
                    <a
                      :href="`https://giraffesoftware.atlassian.net/browse/${data.item.key}`"
                    >{{data.item.key}}</a>
                  </template>
                </NestedTable>
              </template>
            </TableForPage>
          </div>
        </div>
      </template>
    </FullscreenTabs>
  </section>
</template>

<script>
import Filters from '@components/Filter/Filter'
import FullscreenTabs from '@components/Fullscreen/FullscreenTabs'
import TableForPage from '@tables/TableForPage'
import NestedTable from '@tables/NestedTable'

export default {
  name: 'backlog-time-report',
  components: {
    Filters,
    FullscreenTabs,
    TableForPage,
    NestedTable
  },
  data () {
    return {
      showPreloader: false,
      isShowFilter: true,
      currentTab: { name: 'byProject', alias: 'By Project' },
      tabs: [
        { name: 'byProject', alias: 'By Project' },
        { name: 'byPeople', alias: 'byPeople' }
      ],
      filters: {
        'projects': {
          type: 'multiselect',
          name: 'projects',
          label: 'Select projects',
          valueField: 'key',
          selectLabel: 'name',
          options: [],
          value: [],
          class: 'col-md-3'
        },
        'users': {
          type: 'multiselect',
          name: 'users',
          label: 'Select users',
          valueField: 'jira_user_name',
          selectLabel: 'name',
          options: [],
          value: [],
          class: 'col-md-3'
        },
        'unitManagers': {
          type: 'multiselect',
          name: 'unitManagers',
          label: 'Select unit managers',
          valueField: 'jira_user_name',
          selectLabel: 'name',
          options: [],
          value: [],
          class: 'col-md-3'
        }
      },
      transProps: {
        // Transition name
        name: 'flip-list'
      },
      form: {
        projects: [],
        users: [],
        unitManagers: []
      },
      projects: [],
      users: [],
      unitManagers: [],
      slotsProjects: {
        key: {
          name: 'key'
        }
      },
      fieldsProjects: [
        {
          key: 'key',
          sortable: true
        },
        {
          key: 'name',
          sortable: true
        },
        {
          key: 'remaining',
          label: 'Remaining Time',
          sortable: true
        },
        {
          key: 'tasks',
          label: 'Tasks',
          class: 'tasks-btn-col'
        }
      ],
      slotsNestedPeople: {
        key: {
          name: 'key'
        }
      },
      fieldsPeople: [
        {
          key: 'unit_manager_name',
          label: 'Unit manager',
          sortable: true
        },
        {
          key: 'name',
          label: 'Developer',
          sortable: true
        },
        {
          key: 'remaining',
          label: 'Remaining time',
          sortable: true
        },
        {
          key: 'more',
          label: 'More',
          class: 'column-more'
        }
      ],
      fieldsNestedPeople: [
        {
          key: 'key',
          sortable: true
        },
        {
          key: 'name',
          sortable: true
        },
        {
          key: 'remaining',
          label: 'Remaining Time',
          sortable: true
        },
        {
          key: 'more',
          label: 'Tasks',
          class: 'column-more'
        }
      ],
      fieldsModalPeople: [
        {
          key: 'key',
          label: 'Key',
          sortable: true
        },
        {
          key: 'summary',
          label: 'Summary',
          sortable: true
        },
        {
          key: 'status',
          label: 'Status',
          sortable: true
        },
        {
          key: 'remainingEstimateFormat',
          label: 'Remaining Estimate',
          sortable: true
        }
      ],
      slotsModalPeople: {
        key: {
          name: 'key'
        }
      },
      reportsByUsers: [],
      reportsByProject: []
    }
  },
  methods: {
    setModalTitle (item, nestedRow) {
      return `Tasks of user ${item.row.item.name} for the project "${nestedRow.name}"`
    },
    setCurrentTab (tab) {
      this.currentTab = tab
    },
    toggleShowFilter () {
      this.isShowFilter = !this.isShowFilter
    },
    prepareDataForGetReports (fields) {
      let data = {}

      for (let key in fields) {
        const name = fields[key]['name']
        let value = fields[key]['value']

        if (Object.prototype.toString.call(value) === '[object Date]') {
          value = this._toLocalTime(value)
        }

        if (Array.isArray(value)) {
          value = value.map(item => item[fields[key]['valueField']])
        }

        data[name] = value
      }

      return data
    },
    resetPagination () {
      this.$refs['tablePeople'].resetPagination()
      this.$refs['tableProject'].resetPagination()
    },
    async filterReport (fields) {
      this._setRouteByFields(fields)
      await this.getReportAdpt(fields)
      this.resetPagination()
    },
    getReportAdpt (fields) {
      const data = this.prepareDataForGetReports(fields)
      this.getReport(data)
    },
    checkAllEmptyFields (fields) {
      let isEmpty = true

      for (let field in fields) {
        if (field.length) {
          isEmpty = false
          break
        }
      }

      return isEmpty
    },
    /* TODO optimization and replace getReportAdpt */
    getReport (fields) {
      if (this.$route.query.userId) {
        const userId = this.$route.query.userId
        const user = this.users.find(item => item.id === +userId)
        this.filters.value.push(user)
      }

      const isEmptyFileds = this.checkAllEmptyFields(fields)

      if (isEmptyFileds) {
        return
      }

      this.showPreloader = true
      return this.axios
        .post(
          '/api/report/backlogTime',
          fields,
          {
            headers: {
              Authorization: 'Bearer' + this.$store.getters.getAccessToken
            }
          }
        )
        .then(response => {
          if (response.status === 200) {
            this.reportsByUsers = Object.values(response.data.users)
            this.reportsByProject = Object.values(response.data.totalByProject)
          }
        })
        .catch(err => {
          console.log(err)
          var errors = Object.values(err.response.data.errors)
          for (var i = 0; i < errors.length; i++) {
            this.$snotify.error(
              errors[i][0],
              'Error',
              this.$store.state.snotify
            )
          }
        })
        .finally(() => {
          this.showPreloader = false
          this.firstLoading = false
        })
    },
    onReset () {
      /* Reset our form values */
      this.form.projects = []
      this.form.users = []
      this.form.unitManagers = []
      /* Trick to reset/clear native browser form validation state */
      this.$nextTick(() => {
        this.show = true
      })
    }
  },
  computed: {
    sortReportsByUsers () {
      let userProjects = []
      this.reportsByUsers.forEach((element, index) => {
        userProjects = element.projects.filter(item => {
          if (item.remaining.replace(/\s+/g, '') !== '0h') {
            return item
          }
        })
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.reportsByUsers[index].projects = userProjects
      })
      return this.reportsByUsers
    }
  },
  async created () {
    if (this.$can('read_own-backlog_reports') && !this.$can('read_all-backlog_reports')) {
      this.showPreloader = true
      this.form.users.push(this._UserInfo)
      this.filters.users.value.push(this._UserInfo)
    }
    if (this.$route.query.userId) {
      this.showPreloader = true
    }
    await this.axios
      .get('/api/jiraProjects', {
        headers: {
          Authorization: 'Bearer' + this.$store.getters.getAccessToken
        }
      })
      .then(response => {
        if (response.status === 200) {
          this.projects = response.data
          this.filters.projects.options = response.data
        }
      })
      .catch(err => {
        console.log(err)
      })
    await this.axios
      .post(
        '/api/users',
        {},
        {
          headers: {
            Authorization: 'Bearer' + this.$store.getters.getAccessToken
          }
        }
      )
      .then(response => {
        if (response.status === 200) {
          this.users = response.data
          this.filters.users.options = response.data
        }
      })
      .catch(err => {
        console.log(err)
      })
    await this.axios
      .post(
        '/api/get-unit-managers',
        {
          unit_managers: []
        },
        {
          headers: {
            Authorization: 'Bearer' + this.$store.getters.getAccessToken
          }
        }
      )
      .then(response => {
        if (response.status === 200) {
          this.unitManagers = response.data
          this.filters.unitManagers.options = response.data
          if (Object.keys(this.$route.query).length !== 0) {
            for (let item in this.$route.query) {
              if (item.indexOf('users') !== -1) {
                this.users.forEach((element, index) => {
                  if (element.id === +this.$route.query[item]) {
                    this.form.users.push(element)
                    this.filters.users.value.push(element)
                  }
                })
              } else if (item.indexOf('unitManagers') !== -1) {
                this.unitManagers.forEach((element, index) => {
                  if (element.id === +this.$route.query[item]) {
                    this.form.unitManagers.push(element)
                    this.filters.unitManagers.value.push(element)
                  }
                })
              } else {
                this.projects.forEach((element, index) => {
                  if (element.id === +this.$route.query[item]) {
                    this.form.projects.push(element)
                    this.filters.projects.value.push(element)
                  }
                })
              }
            }
          }
        }
      })
      .catch(err => {
        console.log(err)
      })
    if (this.$route.query.userId) {
      await this.getReportAdpt(this.filters)
    }
    if (this.$can('read_own-backlog_reports') && !this.$can('read_all-backlog_reports')) {
      await this.getReportAdpt(this.filters)
    }
  }
}
</script>

<style scoped>
table.table-transition {
  transition: transform 1s;
}
</style>

<style>
.tasks-btn-col {
  width: 100px !important;
}
</style>
